import axios from 'axios';

import { logoutAction, OAuthAuthenticationService } from '@ipc/ipc-core';
import store from '../store';
import { getAuthTokenState } from '../components/common/redux/selectors/authInfoSelector';
import { newErrorNotification } from '../components/common/redux/actions/notificationActions';
import { RECEPTACLE_SEARCH_FORM_DATA } from '../pages/ReceptacleSearchCriteria/constants';

export const POST = 'post';
export const GET = 'get';
export const DELETE = 'delete';
export const PUT = 'put';
export const PATCH = 'patch';

export const paramsSerializer = (params) => {
  const str = [];
  const keys = Object.keys(params);
  for (let i = 0; i < keys.length; i += 1) {
    const propertyName = keys[i];
    if (params[propertyName] !== undefined) {
      str.push(`${encodeURIComponent(propertyName)}=${encodeURIComponent(params[propertyName])}`);
    }
  }

  return str.join('&');
};

const getResponseData = response => (response.data && response.data.data ? response.data.data : response.data || response);

export default (url, requestOptions = {}) => {
  const tokenPayload = getAuthTokenState(store.getState());

  const options = {
    url,
    baseURL: process.env.apiUrl,
    method: GET,
    paramsSerializer,
    headers: {},
    ...requestOptions,
  };

  if (tokenPayload) {
    if (typeof tokenPayload === 'string') {
      options.headers.Authorization = `bearer ${tokenPayload}`;
    } else if (tokenPayload.access_token) {
      options.headers.Authorization = `bearer ${tokenPayload.access_token}`;
    }
  }

  let request;

  switch (options.method) {
  case POST:
  case PATCH:
  case PUT:
    request = axios[options.method](url, requestOptions.body, options);
    break;
  default:
    request = axios(options);
    break;
  }

  return request
    .then((response) => {
      const responseData = getResponseData(response);
      if (requestOptions.responseType === 'blob' && responseData) {
        const filename = response.headers['content-disposition'].split('filename=')[1];
        const newUrl = window.URL.createObjectURL(responseData);
        const anchor = document.createElement('a');
        anchor.href = newUrl;
        anchor.target = '_blank';
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(newUrl);
      }
      return responseData;
    })
    .catch(({ response }) => {
      const { error } = response.data;

      if (error && error.message) {
        store.dispatch(newErrorNotification(error.message, 5));
      }

      switch (response.status) {
      case 401:
        localStorage.removeItem(RECEPTACLE_SEARCH_FORM_DATA);
        store.dispatch(logoutAction());
        store.dispatch(newErrorNotification('Your session expired, please log in!', 5));
        OAuthAuthenticationService.logout();
        break;
      case 403:
        localStorage.removeItem(RECEPTACLE_SEARCH_FORM_DATA);
        store.dispatch(newErrorNotification('Access Denied', 5));
        break;
      case 412:
        store.dispatch(newErrorNotification('No receptacles match that criteria', 5));
        break;
      case 500:
        store.dispatch(newErrorNotification('Internal Server Error, please try again later!', 5));
        break;
      default:
        break;
      }
    });
};
